import { memo } from "react";
import { Button } from "@mui/material";
import makeStyles from "@mui/styles/makeStyles";
import { View } from "../../View";
import { palette } from "../../../theme/palette";

const useStyles = makeStyles({
  container: {
    width: "100%",
    display: "flex",
    justifyContent: "space-between",
    padding: "16px",
    marginTop: "10px",
  },
  yellow: {
    background: palette.btn.yellowFill,
    color: palette.typography.black.high,
    border: palette.btn.yelloBorder,
    boxShadow: "none",
    "&:hover": {
      background: palette.btn.yellowFill,
    },
  },
  blue: {
    background: palette.btn.blueFill,
    color: palette.typography.white.high,
    border: palette.btn.blueBorder,
    boxShadow: "none",
    "&:hover": {
      background: palette.btn.blueFill,
    },
  },
});

export const DriverManagementExpiredActions = memo(
  ({ disabled, onCancel, onContinue }) => {
    const styles = useStyles();

    return (
      <View className={styles.container}>
        <Button
          className={styles.yellow}
          variant={"contained"}
          onClick={onCancel}
        >
          Close
        </Button>
        <Button
          className={styles.blue}
          variant={"contained"}
          onClick={onContinue}
          disabled={disabled}
        >
          Reload
        </Button>
      </View>
    );
  }
);
